import { render } from "./visit.vue?vue&type=template&id=24aed3f2&scoped=true&bindings={}"
import script from "./visit.vue?vue&type=script&lang=ts"
export * from "./visit.vue?vue&type=script&lang=ts"

import "./visit.vue?vue&type=style&index=0&id=24aed3f2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24aed3f2"

export default script